import type { AppRouteRecordRaw } from '@/router/types'

export const callCenterConfigRoutes: AppRouteRecordRaw[] = [
  {
    path: 'callCenterConfig',
    name: 'CallCenterConfig',
    component: () => import('@/views/systemManage/callCenterConfig/index.vue'),
    meta: {
      title: '呼叫中心配置'
    },
    children: [
      {
        path: 'openCallCenter',
        name: 'OpenCallCenter',
        component: () => import('@/views/systemManage/callCenterConfig/openCallCenter/index.vue'),
        meta: {
          title: '开通呼叫中心'
        }
      },
      {
        path: 'seatManage',
        name: 'SeatManage',
        component: () => import('@/views/systemManage/callCenterConfig/seatManage/index.vue'),
        meta: {
          title: '坐席管理'
        }
      },
      {
        path: 'deviceManage',
        name: 'DeviceManage',
        component: () => import('@/views/systemManage/callCenterConfig/deviceManage/index.vue'),
        meta: {
          title: '设备管理'
        }
      },
      {
        path: 'blacklistValidate',
        name: 'BlacklistValidate',
        component: () =>
          import('@/views/systemManage/callCenterConfig/blacklistValidate/index.vue'),
        meta: {
          title: '黑名单校验'
        }
      },
      {
        path: 'callSetup',
        name: 'CallSetup',
        component: () => import('@/views/systemManage/callCenterConfig/callSetup/index.vue'),
        meta: {
          title: '通话设置'
        }
      }
    ]
  }
]
